// extracted by mini-css-extract-plugin
module.exports = {"header":"_22fO1V8sWhAILAd5Y9gwV5","title":"_185d0asDdhZ8SBYteNXlD appSubtitle","products":"JSe_HkWshZt-DuLqwHPJG"};